import React from "react";
import PublicNavbar from "../../components/public/PublicNavbar";
import { Link } from "react-router-dom";

const Terms = () => {
    return (
        <div className="min-h-screen bg-[#FFFFFF] text-[#263746] font-sans">
            <PublicNavbar />

            <div className="bg-[#F7F5EF] border-b border-[#E5E7EB] py-12 px-6 text-center">
                <div className="max-w-4xl mx-auto">
                    <span className="text-[#E3B629] text-xs font-black tracking-[0.25em] uppercase block mb-1">
                        Commercial Terms
                    </span>
                    <h1 className="text-3xl sm:text-4xl font-extrabold text-[#263746]">
                        Terms and Conditions
                    </h1>
                    <p className="text-[#687482] text-xs sm:text-sm mt-2">
                        LUMIGO PROJECTION SOLUTIONS • By Fourlifters Private Limited • B2B Commercial Supply Terms
                    </p>
                </div>
            </div>

            <div className="max-w-4xl mx-auto px-6 py-12 space-y-8 text-[#687482] text-xs sm:text-sm leading-relaxed">
                <div className="p-4 rounded-xl bg-amber-50 border border-amber-200 text-amber-900 text-xs font-medium">
                    <strong>Commercial Supply Policy:</strong> These terms govern the product enquiry, technical review, and quotation workflow for commercial gobo projection systems provided by LUMIGO (Fourlifters Private Limited).
                </div>

                <section className="space-y-3">
                    <h2 className="text-base font-bold text-[#263746] uppercase tracking-wider">
                        1. Nature of the Website & Enquiry-Based Model
                    </h2>
                    <p>
                        The LUMIGO website serves as a commercial product catalogue and enquiry submission platform. Submitting an enquiry or quote request does not constitute an accepted or confirmed purchase order. A binding commercial transaction only exists once a formal written quotation is issued by Fourlifters Private Limited and formally accepted by both parties.
                    </p>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-bold text-[#263746] uppercase tracking-wider">
                        2. Pricing & Indicative Figures
                    </h2>
                    <p>
                        All prices displayed on the website are strictly indicative and subject to written quotation. Prices may vary based on project scale, lens optical throw distance requirements, custom laser-etched dichroic glass gobo fabrication, applicable GST, and logistics charges. LUMIGO reserves the right to correct indicative prices prior to formal quote issuance.
                    </p>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-bold text-[#263746] uppercase tracking-wider">
                        3. Payment Terms & No Online Payment Collection
                    </h2>
                    <p>
                        <strong>No online payment gateway or automated credit/debit card processing exists on this platform.</strong> Payment arrangements are established offline directly with the business (via verified electronic bank transfer / RTGS / NEFT / direct corporate account) upon formal quotation confirmation.
                    </p>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-bold text-[#263746] uppercase tracking-wider">
                        4. Custom Gobo Artwork & Intellectual Property
                    </h2>
                    <p>
                        Clients submitting logos, monograms, trademarks, or graphic designs for custom gobo glass manufacturing warrant that they possess all required rights, ownership, or licensing for the submitted artwork. Fourlifters Private Limited disclaims liability for any trademark or copyright infringement arising from client-supplied artwork.
                    </p>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-bold text-[#263746] uppercase tracking-wider">
                        5. Product Specifications & Verification
                    </h2>
                    <p>
                        Hardware specifications (including rated power, luminous flux, rated lifetime, and IP ratings) reflect manufacturer stated ratings and technical lab benchmarks. Where marked as pending on-site verification, specifications are subject to confirmation prior to project installation.
                    </p>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-bold text-[#263746] uppercase tracking-wider">
                        6. Contact & Corporate Identity
                    </h2>
                    <p>
                        For any queries regarding commercial terms, please contact:
                    </p>
                    <ul className="list-disc list-inside space-y-1 text-[#263746] font-semibold text-xs">
                        <li>Corporate Entity: Fourlifters Private Limited (Brand: LUMIGO)</li>
                        <li>Registered Works: E-21/22, Kaygee Engineering Premises, T Block, MIDC Bhosari, Pune, Maharashtra, India - 411026</li>
                        <li>GST NO.: 27AAECF6202G1ZX</li>
                        <li>Emails: fourlifters@gmail.com / sales@fourlifters.in</li>
                        <li>WhatsApp / Mobile: +91 8087680893</li>
                        <li>Website: www.fourlifters.in</li>
                    </ul>
                </section>

                <div className="pt-6 border-t border-[#E5E7EB] text-center">
                    <Link to="/contact" className="text-[#E3B629] font-bold hover:underline text-xs">
                        Have questions about commercial terms? Contact our desk &rarr;
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Terms;
